import emailValidator from 'email-validator';
import { ratePassword } from '../util/ratePassword';
const defaultValidation = (value) => value.length === 0 ? 'This field is required' : '';
const isEINValid = (ein) => ein.length > 0 && /^\d{2}-\d{7}$/.test(ein);
const isEmailValid = (email) => email.length > 0 && emailValidator.validate(email);
const isValidRoutingNumber = (routingNumber) => routingNumber.length > 0 && /^[0-9]{9}$/.test(routingNumber);
const isValidBankAccountNumber = (accountNumber) => accountNumber.length > 0 && /^[0-9]{1,17}$/.test(accountNumber);
const validateEmail = (email) => {
    if (email.length === 0) {
        return 'This field is required';
    }
    if (!isEmailValid(email)) {
        return 'Please enter a valid email address';
    }
    return '';
};
const validateConfirmEmail = (confirmEmail, email) => {
    if (confirmEmail.length === 0) {
        return 'This field is required';
    }
    if (confirmEmail.length > 0 && confirmEmail !== email) {
        return 'The email addresses do not match';
    }
    return '';
};
const validatePassword = (password) => {
    if (password.length === 0) {
        return 'This field is required';
    }
    const rating = ratePassword(password);
    if (rating <= 2) {
        return 'Password strength is too low';
    }
    return '';
};
const validateConfirmPassword = (confirmPassword, password) => {
    if (confirmPassword.length === 0) {
        return 'This field is required';
    }
    if (confirmPassword !== password) {
        return 'Passwords do not match';
    }
    return '';
};
const validatePhone = (password) => {
    if (password.length === 0) {
        return 'This field is required';
    }
    if (password.length < 10) {
        return 'Please enter a valid phone number with area code';
    }
    return '';
};
const validateEmployeeNumber = (numberOfEmployeesStr) => {
    const numberOfEmployees = parseInt(numberOfEmployeesStr, 10);
    if (Number.isNaN(numberOfEmployees) || numberOfEmployees < 1) {
        return 'Please enter a value greater than 0';
    }
    return '';
};
const validateRoutingNumber = (routingNumber) => {
    const requiredFieldMessage = defaultValidation(routingNumber);
    if (requiredFieldMessage) {
        return requiredFieldMessage;
    }
    if (!isValidRoutingNumber(routingNumber)) {
        return 'Please enter a valid 9 digit routing number';
    }
    return '';
};
const validateConfirmRoutingNumber = (routingNumber, confirmRoutingNumber) => {
    const requiredFieldMessage = defaultValidation(confirmRoutingNumber);
    if (requiredFieldMessage) {
        return requiredFieldMessage;
    }
    if (routingNumber !== confirmRoutingNumber) {
        return 'Routing numbers do not match';
    }
    return '';
};
const validateBankAccountNumber = (accountNumber) => {
    const requiredFieldMessage = defaultValidation(accountNumber);
    if (requiredFieldMessage) {
        return requiredFieldMessage;
    }
    if (!isValidBankAccountNumber(accountNumber)) {
        return 'Please enter a valid bank account number between 1 and 17 characters';
    }
    return '';
};
const validateConfirmBankAccountNumber = (accountNumber, confirmAccountNumber) => {
    const requiredFieldMessage = defaultValidation(confirmAccountNumber);
    if (requiredFieldMessage) {
        return requiredFieldMessage;
    }
    if (accountNumber !== confirmAccountNumber) {
        return 'Bank account numbers do not match';
    }
    return '';
};
export { defaultValidation, isEmailValid, isEINValid, validateEmail, validateConfirmEmail, validatePassword, validateConfirmPassword, validatePhone, validateEmployeeNumber, validateRoutingNumber, validateConfirmRoutingNumber, validateBankAccountNumber, validateConfirmBankAccountNumber };
